// Curated Unsplash photography (free license). Art direction: dark neutral environments, natural
// collaboration, cinematic depth. Treatment (contrast/warm accent) is applied in CSS, not baked in.
export const PHOTOS = {
  staffingTeam: { id: "1522071820081-009f0129c71c", alt: "Diverse technology team collaborating over laptops in a modern workspace", pos: "center 40%" },
  softwarePair: { id: "1531482615713-2afd69097998", alt: "Two engineers reviewing code together at a dark workstation", pos: "center" },
  softwareDev: { id: "1581094794329-c8112a89af12", alt: "Developer working across multiple monitors filled with code", pos: "center" },
  aiWorkstation: { id: "1551434678-e076c223a692", alt: "Machine learning engineer reviewing model output across two monitors", pos: "center" },
  dataDashboards: { id: "1551288049-bebda4e38f71", alt: "Business intelligence dashboards on a laptop screen", pos: "center" },
  dataScreens: { id: "1526628953301-3e589a6a8b74", alt: "Analytics charts glowing on dark monitors", pos: "center" },
  cloudDatacenter: { id: "1558494949-ef010cbdcc31", alt: "Server racks and structured cabling in an enterprise data center", pos: "center" },
  cloudCorridor: { id: "1573164713988-8665fc963095", alt: "Engineer walking through a blue-lit data center corridor", pos: "center" },
  architecture: { id: "1532619675605-1ede6c2ed2b0", alt: "Two engineers sketching system architecture on a whiteboard", pos: "center" },
  enterpriseOffice: { id: "1504384308090-c894fdcc538d", alt: "Large open-plan technology office with teams at work", pos: "center" },
  enterpriseIT: { id: "1541746972996-4e0b0f43e02a", alt: "Technology leadership meeting in a glass-walled office at night", pos: "center" },
  enterpriseTeam: { id: "1521737711867-e3b97375f902", alt: "Technology team working together in warm evening light", pos: "center 35%" },
  leadership: { id: "1542744173-8e7e53415bb0", alt: "Executives in a strategy meeting around a conference table", pos: "center" },
  consulting: { id: "1568992687947-868a62a9f521", alt: "Consultants in discussion at a long table in a dark modern space", pos: "center" },
  securityTeam: { id: "1519241047957-be31d7379a5d", alt: "IT professionals monitoring systems in a dark operations room", pos: "center" },
  healthcare: { id: "1666214280557-f1b5022eb634", alt: "Healthcare professionals reviewing diagnostic imaging on a monitor", pos: "center" },
  manufacturing: { id: "1581091226825-a6a2a5aee158", alt: "Engineer working on a laptop inside an advanced manufacturing facility", pos: "center" },
  finance: { id: "1454165804606-c3d57bc86b40", alt: "Finance professionals reviewing figures across laptops and documents", pos: "center" },
  professional: { id: "1517245386807-bb43f82c33c4", alt: "Professional services team collaborating around laptops", pos: "center" },
  officeAdmin: { id: "1565728744382-61accd4aa148", alt: "Office professionals working together at a shared desk", pos: "center" },
  technologyTeam: { id: "1556761175-b413da4baf72", alt: "Technology team at desks in a loft-style office", pos: "center" },
  partnership: { id: "1521791136064-7986c2920216", alt: "Two business partners shaking hands in an office", pos: "center" },
};

export const SERVICE_PHOTOS = {
  "ai-ml": "aiWorkstation",
  "generative-ai": "dataScreens",
  "data-engineering": "dataDashboards",
  "ai-automation": "architecture",
  "cloud-ai-infrastructure": "cloudDatacenter",
  "custom-software": "softwareDev",
};

export const SOLUTION_PHOTOS = {
  "ai-transformation": "aiWorkstation",
  "digital-transformation": "leadership",
  "cloud-transformation": "cloudCorridor",
  "data-transformation": "dataScreens",
  "intelligent-automation": "architecture",
  "enterprise-software": "softwarePair",
  "workforce-transformation": "staffingTeam",
  "technology-modernization": "enterpriseIT",
};

export const INDUSTRY_PHOTOS = {
  "office-administration": "officeAdmin",
  "healthcare-staffing": "healthcare",
  "manufacturing-staffing": "manufacturing",
  "technology-staffing": "technologyTeam",
  "financial-services": "finance",
  "professional-services": "professional",
};

export const CASE_PHOTOS = { AI: "aiWorkstation", Cloud: "cloudCorridor", Software: "softwarePair", Data: "dataDashboards", Automation: "architecture", Staffing: "staffingTeam" };

// Inner-page hero spotlight sets (slow crossfade, 2–3 photos each)
export const HERO_SETS = {
  services: ["enterpriseIT", "softwareDev", "cloudDatacenter"],
  solutions: ["cloudCorridor", "dataScreens", "architecture"],
  about: ["leadership", "enterpriseTeam", "consulting"],
  industries: ["staffingTeam", "healthcare", "manufacturing"],
  caseStudies: ["consulting", "dataDashboards", "softwarePair"],
  careers: ["enterpriseTeam", "technologyTeam", "softwarePair"],
  partnership: ["partnership", "leadership", "professional"],
  contact: ["enterpriseOffice", "officeAdmin", "staffingTeam"],
};

const WIDTHS = [480, 768, 1080, 1440, 1920];
export const photoSrc = (id, w = 1440, h) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&q=72&w=${w}${h ? `&h=${h}` : ""}`;
export const photoSrcSet = (id, ratio) => WIDTHS.map((w) => `${photoSrc(id, w, ratio ? Math.round(w / ratio) : undefined)} ${w}w`).join(", ");
